var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDocumentoFirmaUteg = function SvgDocumentoFirmaUteg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h55v55H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#documento-firma-uteg_svg__a)",
    fill: "#E8183B"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.506 53.706V49.99a3.999 3.999 0 0 1 2.578-3.74c1.39-.517 3.332-.987 5.852-.987 2.52 0 4.462.47 5.851.988a3.999 3.999 0 0 1 2.579 3.74v3.715M28.668 36.984c0 2.493-1.637 4.445-3.662 4.445s-3.661-1.952-3.661-4.445c0-2.493 1.636-3.928 3.661-3.928 2.025 0 3.662 1.435 3.662 3.928Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.363 47.12a17.9 17.9 0 0 0-1.413-.058c-2.66 0-4.639.553-5.946 1.117-1.2.506-1.966 1.705-1.966 2.999v2.81h39.936v-2.81a3.241 3.241 0 0 0-1.966-2.999c-1.319-.553-3.297-1.117-5.946-1.117a17.9 17.9 0 0 0-1.413.059M15.87 39.03c0 2.34-1.542 4.175-3.438 4.175-1.896 0-3.438-1.835-3.438-4.175s1.543-3.68 3.438-3.68c1.896 0 3.438 1.352 3.438 3.68ZM34.12 39.03c0 2.34 1.541 4.175 3.437 4.175s3.438-1.835 3.438-4.175-1.542-3.68-3.438-3.68c-1.896 0-3.438 1.352-3.438 3.68ZM40.97 19.569h2.709c2.39 0 4.32-1.94 4.32-4.34V6.34C48 3.94 46.07 2 43.68 2H22.828c-2.39 0-4.321 1.94-4.321 4.34v8.877c0 2.4 1.93 4.34 4.32 4.34h6.665a7.19 7.19 0 0 1 4.18 1.34l7.299 5.186v-6.526.012Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.82 19.886v2.199c0 2.399-1.93 4.34-4.32 4.34h-4.992c-1.495 0-2.967.47-4.18 1.34l-7.3 5.186v-6.527H5.322C2.93 26.424 1 24.484 1 22.085v-8.878c0-2.4 1.93-4.34 4.32-4.34h13.01"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "documento-firma-uteg_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(1 2)",
    d: "M0 0h47v52H0z"
  })))));
};
export default SvgDocumentoFirmaUteg;